import React from 'react';
import { ChevronLeft, Mail } from 'lucide-react';

const ContactSupport = () => {
    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 via-gray-100 to-gray-200 dark:from-slate-950 dark:via-slate-950 dark:to-slate-950 flex justify-center py-8">
            <div className="w-full max-w-3xl px-4 lg:px-8">
                <button
                    onClick={() => window.location.hash = '/'}
                    className="inline-flex items-center text-gray-600 hover:text-gray-900 dark:text-slate-400 dark:hover:text-slate-200 font-medium mb-8 transition-colors"
                >
                    <ChevronLeft size={18} className="mr-1" />
                    Back to Home
                </button>

                <article className="bg-white dark:bg-slate-900 rounded-3xl shadow-xl p-8 md:p-12 border border-gray-200 dark:border-slate-800">
                    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Contact & Support</h1>

                    <div className="prose dark:prose-invert max-w-none text-gray-600 dark:text-slate-300 mb-8">
                        <p>
                            Have questions, feedback, or need assistance? Our team is here to help.
                            We aim to respond to all messages within 1–2 business days.
                        </p>
                        <p>
                            Whether you’re reporting a bug, suggesting a new feature, or requesting support,
                            feel free to reach out through the email below.
                        </p>
                    </div>

                    <div className="p-6 bg-gray-50 dark:bg-slate-800 rounded-2xl border border-gray-100 dark:border-slate-700 flex flex-col items-center justify-center text-center">
                        <div className="bg-red-100 dark:bg-red-900/30 p-4 rounded-full mb-4">
                            <Mail className="w-8 h-8 text-red-600 dark:text-red-400" />
                        </div>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Email Support</h2>
                        <p className="text-gray-600 dark:text-slate-400 mb-4">
                            For all inquiries, please email us at:
                        </p>
                        <a
                            href="mailto:info@askstudios.ca"
                            className="text-lg font-semibold text-red-600 dark:text-red-400 hover:underline"
                        >
                            info@askstudios.ca
                        </a>
                    </div>

                    <div className="mt-10 grid gap-6">
                        <div className="p-5 bg-white/70 dark:bg-slate-800/80 rounded-xl border border-gray-200 dark:border-slate-700">
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">Feature Requests</h3>
                            <p className="text-gray-600 dark:text-slate-400">
                                Have an idea to make BrieflyCA better? We welcome suggestions.
                                Send them to:
                                {" "}
                                <a
                                    href="mailto:info@askstudios.ca"
                                    className="text-red-600 dark:text-red-400 hover:underline"
                                >
                                    info@askstudios.ca
                                </a>
                            </p>
                        </div>

                        <div className="p-5 bg-white/70 dark:bg-slate-800/80 rounded-xl border border-gray-200 dark:border-slate-700">
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">Press & Partnerships</h3>
                            <p className="text-gray-600 dark:text-slate-400">
                                For media, collaboration, or partnership opportunities, please contact:
                                {" "}
                                <a
                                    href="mailto:info@askstudios.ca"
                                    className="text-red-600 dark:text-red-400 hover:underline"
                                >
                                    info@askstudios.ca
                                </a>
                            </p>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    );
};

export default ContactSupport;
